import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reward-plan',
  templateUrl: './reward-plan.component.html',
  styleUrls: ['./reward-plan.component.scss']
})
export class RewardPlanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
